import { guardArray, uniqueArray } from "@msuite/utils/array";
import { z } from "@msuite/utils/lib/zod";
import { defineMutator } from "@rocicorp/zero";
import { Guards } from "../handlers/guards.handlers";

export const planMutators = {
	batchSkipTickets: defineMutator(
		z.object({
			planId: z.uuid(),
			ticketIds: z.array(z.uuid()),
		}),
		async ({ tx, args, ctx }) => {
			const currentPlan = await Guards.assertPlanOnEditableDay(tx, ctx, args.planId);
			const currentSkippedTickets = guardArray(currentPlan.skippedTickets);
			const newSkippedTickets = uniqueArray(currentSkippedTickets.concat(args.ticketIds));
			return await tx.mutate.plans.update({
				id: args.planId,
				skippedTickets: newSkippedTickets,
			});
		},
	),
	toggleSkippedTicket: defineMutator(
		z.object({
			planId: z.uuid(),
			ticketId: z.uuid(),
		}),
		async ({ tx, args, ctx }) => {
			const currentPlan = await Guards.assertPlanOnEditableDay(tx, ctx, args.planId);
			const currentSkippedTickets = currentPlan.skippedTickets;
			const isIncluded = currentSkippedTickets?.includes(args.ticketId);
			const newSkippedTickets = guardArray(
				isIncluded
					? currentSkippedTickets?.filter((id) => id !== args.ticketId)
					: currentSkippedTickets?.concat([args.ticketId]),
			);
			return await tx.mutate.plans.update({
				id: args.planId,
				skippedTickets: newSkippedTickets,
			});
		},
	),
	toggleNotificationsEnabled: defineMutator(
		z.object({
			planId: z.uuid(),
		}),
		async ({ tx, args, ctx }) => {
			const currentPlan = await Guards.assertPlanInOrg(tx, ctx, args.planId);
			return await tx.mutate.plans.update({
				id: args.planId,
				notificationsEnabled: !currentPlan.notificationsEnabled,
			});
		},
	),
};
